var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"data_pagination"},[_c('el-pagination',{attrs:{"current-page":_vm.getJournalData.current,"small":_vm.small,"pager-count":_vm.pagerCount,"layout":"prev, pager, next","prev-text":"Previous","next-text":"Next","total":_vm.total},on:{"current-change":_vm.onCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }